/**
 * prop.sync を自動化するコンポジション
 */
import { computed, getCurrentInstance, WritableComputedRef } from '@nuxtjs/composition-api';
import { toPascalCase } from '~/utils';

export const usePropSync = <Props extends Record<string, any>, Keys extends Array<keyof Props>>(
  props: Props,
  ...keys: Keys
) => {
  const vm = getCurrentInstance();
  const syncedProps = Object.fromEntries(
    keys.map((key) => [
      `synced${toPascalCase(`${key}`)}`,
      computed({
        get() {
          return props[key];
        },
        set(value: typeof props[typeof key]) {
          vm?.emit(`update:${key}`, value);
        },
      }),
    ])
  );

  return syncedProps as {
    [Key in Keys[number] as Key extends string ? `synced${Capitalize<Key>}` : never]: WritableComputedRef<Props[Key]>;
  };
};
